import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter
} from '../ui/dialog'
import { Button } from '../ui/button'

const ConfirmationModal = ({ show, onHide, onConfirm, message, title, confirmBtnTxt, cancelBtnTxt }) => {
  return (
    <Dialog open={show} onOpenChange={onHide}>
      <DialogContent className='clr-grey'>
        <DialogHeader closeButton className='clr-grey'>
          <DialogTitle style={{ textAlign: 'center' }}>{title}</DialogTitle>
        </DialogHeader>
        {message}
        <DialogFooter className='clr-grey'>
          {cancelBtnTxt &&
            (
              <Button onClick={onHide}>
                {cancelBtnTxt}
              </Button>
            )}
          {confirmBtnTxt &&
            (
              <Button variant='outline' onClick={onConfirm}>
                {confirmBtnTxt}
              </Button>
            )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmationModal
